// eslint-disable-next-line
import React from 'react';
import { roles } from '../../../../../../constants/roles';
import { getRoomStaffByRole } from '../../../../../../utils/room';
import { Room, RoomStaffMember } from '../../../../../../types/Rooms';

// format staff display
function mapUserToDisplay(user: RoomStaffMember): string {
  const role = roles[user.role] ? ` (${roles[user.role]})` : ' ';
  return `${user.firstName} ${user.lastName ? user.lastName : ''}${role}`;
}

function generateReadOnlyStaffList(room: Room) {
  const currentRoomStaff = [...room.staff];
  const roomStaffList: string[] = [];
  const { admin, proctor, roomMonitors } = getRoomStaffByRole(currentRoomStaff);

  if (admin && admin.length > 0) {
    // coordinators
    admin.forEach((adm) => {
      roomStaffList.push(mapUserToDisplay(adm));
    });
  }

  if (proctor && proctor.length > 0) {
    // proctors
    proctor.forEach((p) => {
      roomStaffList.push(mapUserToDisplay(p));
    });
  }

  // room monitors
  if (roomMonitors && roomMonitors.length > 0) {
    roomMonitors.forEach((rmProc) => {
      roomStaffList.push(mapUserToDisplay(rmProc));
    });
  }

  return roomStaffList.join(', ');
}

interface Props {
  room: Room;
}

export default function Staff({ room }: Props) {
  return <span>{generateReadOnlyStaffList(room) || 'none'}</span>;
}
